import React, { useEffect, useRef } from "react";
import Image from "components/image";
import RichText from "components/rich-text";
import useStickyElement from "hooks/useStickyElement";
import ScrollspyNav from "react-scrollspy-nav";
import clsx from "clsx/lite";
import { formatTitle } from "helpers/format-title";
import { isMobile } from "utils/device-detect";
import { useMediaQuery } from "react-responsive";

const Hero = ({ data }) => {
	data?.tabLinks?.length > 0 && useStickyElement(".sticky-hero");
	const tabsRef = useRef(null);
	const isMobileView = isMobile();
	const isMobileDevice = useMediaQuery({ query: "(max-width: 768px)" });

	useEffect(() => {
		const handleScroll = () => {
			const activeTab = document.querySelector(".active-tab");
			const tabs = tabsRef.current;
			if (activeTab && tabs) {
				const activeTabLeft = activeTab.offsetLeft;
				const activeTabWidth = activeTab.offsetWidth;
				const tabsWidth = tabs.offsetWidth;
				const scrollLeft = activeTabLeft - (tabsWidth / 2) + (activeTabWidth / 2);

				tabs.scrollTo({ left: scrollLeft, behavior: "smooth" });
			}
		};

		handleScroll();
		window.addEventListener("scroll", handleScroll);

		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	const image = isMobileView ? data?.mobileImage : data?.image;

	return (
		<div className="size-full">
			<div className="relative">
				<h1 className={clsx("text-center px-8",
					data?.titlePosition === "left" && "!text-left !left-0 !translate-x-0",
					data?.titlePosition === "right" && "!text-right !right-0 !translate-x-0",
					image?.asset && "text-2xl md:text-6xl absolute z-[5] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
				)}>
					{formatTitle(data.title)}
				</h1>
				{image &&
					<Image
						className="w-full min-h-[22.5rem] max-h-[26.25rem] md:max-h-none h-[34vw] md:h-auto [&>img]:!object-cover"
						image={image}
					/>}
			</div>
			{data?.content?.data && (
				<div className="py-8 px-5 md:px-0 md:w-[55%] mx-auto text-center">
					<RichText value={data?.content} />
				</div>
			)}

			{data?.tabLinks?.length > 0 && (
				<ScrollspyNav
					offset={isMobileDevice ? -100 : -200}
					scrollDuration={100}
					scrollTargetIds={data && [...data?.tabLinks?.map((t) => t?.link?.replace("#", ""))]}
					activeNavClass="active-tab"
				>
					<div style={{ backgroundColor: `${data?.tabsBgColor?.hex || "white"}` }}
						className="flex w-full justify-between mx-auto shadow-tabs overflow-x-auto md:overflow-x-auto sticky-hero">
						<div
							ref={tabsRef}
							className="hero-links-container">
							{data?.tabLinks?.map((t) => (
								<a
									className="flex text-xl justify-between items-start clear-left float-left hero-tab"
									key={t._key}
									href={t.link}
								>
									{t.name}
								</a>
							))}
						</div>
					</div>
				</ScrollspyNav>
			)}
		</div>
	);
};

export default Hero;
